import type { ElementType } from 'react';
import { AlertTriangle, CheckCircle, Info } from 'lucide-react';
import { cn } from '@/lib/utils';

type FlashTone = 'error' | 'success' | 'info';

type FlashBannerProps = {
  message: string;
  tone?: FlashTone;
  className?: string;
};

const TONE_STYLES: Record<
  FlashTone,
  { container: string; icon: ElementType; iconClassName: string; role?: string }
> = {
  error: {
    container: 'border border-border border-l-4 border-l-destructive bg-card text-foreground',
    icon: AlertTriangle,
    iconClassName: 'text-destructive',
    role: 'alert',
  },
  success: {
    container: 'border border-border border-l-4 border-l-green-500 bg-card text-foreground',
    icon: CheckCircle,
    iconClassName: 'text-green-600',
  },
  info: {
    container: 'border border-border border-l-4 border-l-blue-500 bg-card text-foreground',
    icon: Info,
    iconClassName: 'text-blue-600',
  },
};

export function FlashBanner({ message, tone = 'info', className }: FlashBannerProps) {
  const { container, icon: Icon, iconClassName, role } = TONE_STYLES[tone];

  return (
    <div
      className={cn('flex items-center gap-2 rounded-md px-3 py-2 text-sm', container, className)}
      role={role}
    >
      <Icon className={cn('h-4 w-4', iconClassName)} />
      <span>{message}</span>
    </div>
  );
}

export default FlashBanner;
